import {Link} from 'gatsby';
import React from 'react';
import {buildImageObj, imageUrlFor} from './sanity/image-url';

function BlogTeaser(props) {
  return (
    <article className={`article article--sm ${props.showFeatured ? 'article--featured' : ''}`}>
      {props.sourceUrl ? (
        <a href={props.sourceUrl} className="article__big-link" target="_blank" rel="noopener">
          <figure className="article__media">
            {props.thumbnail && props.thumbnail.asset && (
              <img
                src={imageUrlFor(buildImageObj(props.thumbnail))
                  .width(500)
                  .height(280)
                }
              />
            )}
          </figure>
          <div className="article__content">
            {props.sourceName && (
              <div className="article__source-name">
                {props.sourceName}
              </div>
            )}
            <h1 className="article__title">
              {props.title }
            </h1>
            <div className="article__short-body fw--300">
              {props.description && (
                props.description
              )}
            </div>
          </div>
        </a>
      ) : (
        <Link to={`/perspectives/${props.slug.current}`} className="article__big-link">
          <figure className="article__media">
            {props.thumbnail && props.thumbnail.asset && (
              <img
                src={imageUrlFor(buildImageObj(props.thumbnail))
                  .width(500)
                  .height(280)
                }
              />
            )}
          </figure>
          <div className="article__content">
            {props.sourceName && (
              <div className="article__source-name">
                {props.sourceName}
              </div>
            )}
            <h1 className="article__title">
              {props.title }
            </h1>
            <div className="article__short-body fw--300">
              {props.description && (
                props.description
              )}
            </div>
          </div>
        </Link>
      )}
    </article>
  );
}

export default BlogTeaser;
